import { useState } from 'react';
import ImageCard from "../imageCard";
import {XscrollEasy} from "../../../../widgets/XscrollEasy";

const AssetGallery = () => {
    const [images, setImages] = useState([]);

    const handleFileSelect = (event) => {
        const files = event.target.files;
        const newImages = Array.from(files).map((file) => ({
            src: URL.createObjectURL(file),
            prompt: '',
            featured: false,
        }));
        setImages([...images, ...newImages]);
    };

    const handleDelete = (index) => {
        setImages(images.filter((_, i) => i !== index));
    };

    const handleFeature = (index) => {
        setImages(
            images.map((img, i) => ({
                ...img,
                featured: i === index ? !img.featured : img.featured,
            }))
        );
    };

    const handleUpdatePrompt = (index, newPrompt) => {
        setImages(
            images.map((img, i) => ({
                ...img,
                prompt: i === index ? newPrompt : img.prompt,
            }))
        );
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = event.dataTransfer.files;
        const newImages = Array.from(files).map((file) =>
            URL.createObjectURL(file)
        );
        setImages([...images, ...newImages]);
    };

    return (
        <div className="w-full max-w-4xl p-4 bg-stone-50 rounded-lg flex flex-col justify-start items-start gap-3">
            <div className="flex justify-between items-center w-full">
                <div className="text-zinc-800 text-base font-bold">Asset Gallery</div>
                {images.length > 0 && (
                    <button
                        onClick={() => setImages([])}
                        className="flex justify-center items-center gap-1 text-zinc-500 text-xs font-normal">
                        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.5002 3C10.5665 3 10.6301 3.02634 10.677 3.07322C10.7239 3.12011 10.7502 3.1837 10.7502 3.25V3.75C10.7502 3.8163 10.7239 3.87989 10.677 3.92678C10.6301 3.97366 10.5665 4 10.5002 4H9.50025V9.5C9.50025 10.057 9.02024 10.474 8.45349 10.4987L8.40024 10.5H3.60024C3.02874 10.5 2.53124 10.1 2.50174 9.55175L2.50024 9.5V4H1.50024C1.43394 4 1.37035 3.97366 1.32347 3.92678C1.27658 3.87989 1.25024 3.8163 1.25024 3.75V3.25C1.25024 3.1837 1.27658 3.12011 1.32347 3.07322C1.37035 3.02634 1.43394 3 1.50024 3H10.5002ZM8.50024 4H3.50024V9.47225L3.51024 9.47925C3.52995 9.48975 3.55152 9.49629 3.57374 9.4985L3.60024 9.5H8.40024C8.43151 9.50075 8.46246 9.49361 8.49024 9.47925L8.50024 9.472V4ZM5.25024 5.25C5.31655 5.25 5.38014 5.27634 5.42702 5.32322C5.47391 5.37011 5.50024 5.4337 5.50024 5.5V8C5.50024 8.0663 5.47391 8.12989 5.42702 8.17678C5.38014 8.22366 5.31655 8.25 5.25024 8.25H4.75024C4.68394 8.25 4.62035 8.22366 4.57347 8.17678C4.52658 8.12989 4.50024 8.0663 4.50024 8V5.5C4.50024 5.4337 4.52658 5.37011 4.57347 5.32322C4.62035 5.27634 4.68394 5.25 4.75024 5.25H5.25024ZM7.25024 5.25C7.31655 5.25 7.38014 5.27634 7.42702 5.32322C7.47391 5.37011 7.50024 5.4337 7.50024 5.5V8C7.50024 8.0663 7.47391 8.12989 7.42702 8.17678C7.38014 8.22366 7.31655 8.25 7.25024 8.25H6.75024C6.68394 8.25 6.62035 8.22366 6.57347 8.17678C6.52658 8.12989 6.50025 8.0663 6.50025 8V5.5C6.50025 5.4337 6.52658 5.37011 6.57347 5.32322C6.62035 5.27634 6.68394 5.25 6.75024 5.25H7.25024ZM7.25024 1.5C7.28307 1.5 7.31558 1.50647 7.34592 1.51903C7.37625 1.53159 7.40381 1.55001 7.42702 1.57322C7.45024 1.59644 7.46865 1.624 7.48121 1.65433C7.49378 1.68466 7.50024 1.71717 7.50024 1.75V2.25C7.50024 2.3163 7.47391 2.37989 7.42702 2.42678C7.38014 2.47366 7.31655 2.5 7.25024 2.5H4.75024C4.68394 2.5 4.62035 2.47366 4.57347 2.42678C4.52658 2.37989 4.50024 2.3163 4.50024 2.25V1.75C4.50024 1.71717 4.50671 1.68466 4.51927 1.65433C4.53184 1.624 4.55025 1.59644 4.57347 1.57322C4.59668 1.55001 4.62424 1.53159 4.65457 1.51903C4.68491 1.50647 4.71741 1.5 4.75024 1.5H7.25024Z"
                                fill="#888888"/>
                        </svg>
                        Delete All
                    </button>
                )}
            </div>
            <div className={`w-full ${images.length === 0 ? 'border-2 border-dashed border-gray-300' : ''} rounded-lg relative`}>
                {images.length === 0 ? (
                    <div className="flex flex-col justify-center items-center p-4">
                        <div className="text-center text-neutral-700 text-xs font-normal">
                            Drag & Drop or Choose File to Upload Images
                        </div>
                        <div className="text-center text-neutral-400 text-xs font-normal mt-2">
                            * Please show us where you have utilized our assets.
                        </div>
                        <label className="mt-4 w-20 h-20 flex justify-center items-center cursor-pointer">
                            <div className="bg-gray-200 w-full h-full rounded flex justify-center items-center">
                                <span className="text-2xl text-gray-400">&#43;</span>
                            </div>
                            <input
                                type="file"
                                multiple
                                className="absolute inset-0 w-full h-full opacity-0"
                                onChange={handleFileSelect}
                                onDrop={handleDrop}
                                onDragOver={(event) => event.preventDefault()}
                            />
                        </label>
                    </div>
                ) : (
                    <div className="flex py-1 space-x-1">
                        <XscrollEasy disableYScroll={true} contentGap={'2px'}>
                        {images.map((image, index) => (
                            <div key={index} className="flex-shrink-0">
                                <ImageCard
                                    src={image.src}
                                    onDelete={() => handleDelete(index)}
                                    onFeature={() => handleFeature(index)}
                                    isFeatured={image.featured}
                                    defaultPrompt={image.prompt}
                                    onUpdatePrompt={(newPrompt) => handleUpdatePrompt(index, newPrompt)}
                                />
                            </div>
                        ))}
                        <label
                            className="w-20 h-60 flex-shrink-0 flex justify-center items-center cursor-pointer relative">
                            <div className="bg-gray-200 w-full h-full rounded flex justify-center items-center">
                                <span className="text-2xl text-gray-400">&#43;</span>
                            </div>
                            <input
                                type="file"
                                multiple
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                onChange={handleFileSelect}
                                onDrop={handleDrop}
                                onDragOver={(event) => event.preventDefault()}
                            />
                        </label>
                        </XscrollEasy>
                    </div>
                )}

            </div>
        </div>
    );
};

export default AssetGallery;